import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { isOmittedChartParam } from '../legal-analytics/pjud-indicators/pjud-dashboard-charts.util';

@Injectable({
  providedIn: 'root'
})
export class BatchRequirementService {

  constructor(private http: HttpClient) { }

  returnRequirement(body) {
    return this.http.post(`${environment.apiUrl}/trackvision/batchupdaterequirement/apply`, body, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

  changeStatusRequirement(body) {
    return this.http.post(`${environment.apiUrl}/trackvision/batchupdaterequirement/changestatus`, body, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }


  deleteRequirements(body) {
    return this.http.post(`${environment.apiUrl}/trackvision/batchupdaterequirement/delete`, body, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

  getAssigmentUser(body) {
    return this.http.post(`${environment.apiUrl}/trackvision/batchupdaterequirement/getassignableuser`, body, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

  setAssigmentUser(body) {
    return this.http.post(`${environment.apiUrl}/trackvision/batchupdaterequirement/setassigmentuser`, body, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }


  setCollaborator(body) {
    return this.http.post(`${environment.apiUrl}/trackvision/batchupdaterequirement/suscribe`, body, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }


  getActionStatus(body) {
    return this.http.post(`${environment.apiUrl}/trackvision/batchupdaterequirement/getactionstatus`, body, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }


  getReturnCustomFieldByRequirementTypeId(id) {

    return this.http.get(`${environment.apiUrl}/trackvision/batchupdaterequirement/requirementtype/${id}/customfields`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

  getCustomFieldByRequirementTypeIdAndStatuId(body) {
    return this.http.post(`${environment.apiUrl}/trackvision/batchupdaterequirement/getcustomfields`, body, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

  getActionsByTypeRequirement(body) {
    return this.http.post(`${environment.apiUrl}/trackvision/batchupdaterequirement/getactions`, body, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

  setCreator(body) {
    return this.http.post(`${environment.apiUrl}/trackvision/batchupdaterequirement/setcreator`, body, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

  /**
   * Activar o desactivar seguimiento PJUD para los requerimientos indicados.
   * Backend resuelve rit/tribunal/court/competencie/portalUrl por cada id y llama a scraping-pjud.
   * Solo aplica a tipos con config.pjud.enabled definido.
   */
  scrapingToggle(body: { requirementIds: number[]; enabled: boolean }) {
    return this.http.post<{ success: boolean; enabled?: boolean; message?: string; results: Array<{ requirementId: number; success: boolean; message: string }> }>(
      `${environment.apiUrl}/trackvision/batchupdaterequirement/scraping-toggle`,
      body,
      { headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') }
    );
  }

  /** Indicadores PJUD (cupo + estado) desde scraping_pjud. */
  getPjudIndicators(params?: {
    connectedPage?: number;
    connectedPageSize?: number;
    connectedSort?: 'sync' | 'movement';
    notConnectedPage?: number;
    notConnectedPageSize?: number;
    discoveredPage?: number;
    discoveredPageSize?: number;
  }) {
    let httpParams = new HttpParams();
    if (params?.connectedPage != null) {
      httpParams = httpParams.set('connectedPage', String(params.connectedPage));
    }
    if (params?.connectedPageSize != null) {
      httpParams = httpParams.set('connectedPageSize', String(params.connectedPageSize));
    }
    if (params?.connectedSort != null) {
      httpParams = httpParams.set('connectedSort', params.connectedSort);
    }
    if (params?.notConnectedPage != null) {
      httpParams = httpParams.set('notConnectedPage', String(params.notConnectedPage));
    }
    if (params?.notConnectedPageSize != null) {
      httpParams = httpParams.set('notConnectedPageSize', String(params.notConnectedPageSize));
    }
    if (params?.discoveredPage != null) {
      httpParams = httpParams.set('discoveredPage', String(params.discoveredPage));
    }
    if (params?.discoveredPageSize != null) {
      httpParams = httpParams.set('discoveredPageSize', String(params.discoveredPageSize));
    }
    return this.http.get<{ result?: PjudIndicators } & PjudIndicators>(
      `${environment.apiUrl}/trackvision/pjud/indicators`,
      {
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || ''),
        params: httpParams,
      }
    );
  }

  /**
   * Dashboard PJUD: agregados de cartera.
   * GET /trackvision/pjud/indicators/charts
   * Token lo inyecta TokenInterceptor (no duplicar header).
   */
  getPjudCharts(params?: {
    competency?: string | number | null;
    causeStatus?: string | null;
    proceduralStage?: string | null;
    admissionFrom?: string | null;
    admissionTo?: string | null;
  }) {
    let httpParams = new HttpParams();
    const setIf = (key: string, value: string | number | null | undefined) => {
      if (isOmittedChartParam(value)) return;
      httpParams = httpParams.set(key, String(value).trim());
    };
    setIf('competency', params?.competency);
    setIf('causeStatus', params?.causeStatus);
    setIf('proceduralStage', params?.proceduralStage);
    setIf('admissionFrom', params?.admissionFrom);
    setIf('admissionTo', params?.admissionTo);
    return this.http.get<{ result?: PjudCharts } & PjudCharts>(
      `${environment.apiUrl}/trackvision/pjud/indicators/charts`,
      { params: httpParams }
    );
  }

  /**
   * CU-01: tipos elegibles para crear requerimiento desde causa descubierta.
   * GET /trackvision/pjud/indicators/create-types
   * Token lo inyecta TokenInterceptor (no duplicar header).
   */
  getPjudCreateTypes(params: { competency?: string; tribunal?: string }) {
    let httpParams = new HttpParams();
    if (params?.competency != null) {
      httpParams = httpParams.set('competency', String(params.competency));
    }
    if (params?.tribunal != null) {
      httpParams = httpParams.set('tribunal', String(params.tribunal));
    }
    return this.http.get<{ result?: PjudCreateTypesResponse } & PjudCreateTypesResponse>(
      `${environment.apiUrl}/trackvision/pjud/indicators/create-types`,
      { params: httpParams }
    );
  }

  /**
   * Actualizar (renovar) la clave PJUD del cliente desde el monitor, cuando aparece vencida.
   * Reutiliza el puente existente robotpjud/pjudkeys → robot PUT /pjud/credentials, que resuelve el
   * customerName por el Origin del dominio. Al mandar password nueva, el robot vuelve la credencial a
   * 'active' + failureCount=0 (fix del PR de backend). El authMethod se infiere del registro existente
   * si no se envía. NUNCA se manda la clave por query; va en el body (POST/PUT del interceptor con Token).
   */
  updatePjudCredential(payload: { rut: string; password: string; authMethod?: 'clave_unica' | 'clave_pj' }) {
    return this.http.put<{ success?: boolean; message?: string }>(
      `${environment.apiUrl}/robotpjud/pjudkeys`,
      { rut: payload.rut, password: payload.password, ...(payload.authMethod ? { authMethod: payload.authMethod } : {}) },
      { headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') }
    );
  }

}

export interface PjudIndicators {
  customerName?: string | null;
  connected: number;
  /**
   * Causas CONCLUIDAS (sin seguimiento activo): el robot ya no las monitorea.
   * NO suman al total `connected`; se muestran como categoría aparte.
   */
  concluded?: number;
  notConnected: number;
  disconnected: number;
  planLimit: number;
  activeTtas: number;
  percent: number;
  /** Causas conectadas con movimiento nuevo dentro de la ventana freshDays. */
  withNovelties?: number;
  freshDays?: number;
  demo?: boolean;
  /** Estado canónico (solo causas con scraping_enabled). */
  statusBreakdown?: {
    connectedUpToDate: number;
    connectedOutdated: number;
    connectedNoMovements: number;
    connectedPendingReview: number;
    /** Conectadas con causeStatus concluido, contadas aparte (no suman al total). */
    concluded: number;
    /** @deprecated alias histórico de `concluded` (semáforo por fila). */
    connectedClosed?: number;
    pending: number;
    notFound: number;
    reserved: number;
    configCredentialError: number;
    otherErrors: number;
  };
  /** Flujos del tenant con config.pjud.enabled. */
  pjudFlows?: Array<{ id: number; name: string }>;
  /** Página de causas conectadas (cobrables) para la grilla. */
  connectedList?: PjudConnectedList;
  /** Página de causas no conectadas para la grilla. */
  notConnectedList?: PjudNotConnectedList;
  /** Discovery por RUT: pendientes de conectar / RUTs vigilados. */
  rutDiscovery?: {
    discovered: number;
    monitoredRuts: number;
    discoveredLast7Days?: number;
    page: number;
    pageSize: number;
    items?: PjudDiscoveredItem[];
  };
  /** Estado de la credencial PJUD del cliente (para avisar clave vencida + permitir actualizar). */
  credential?: {
    status: 'active' | 'expired' | 'missing' | 'unknown';
    credentials?: Array<{
      rut: string | null;
      authMethod: 'clave_unica' | 'clave_pj';
      status: string;
      expiredAt?: string | null;
      expiredReason?: string | null;
    }>;
  };
}

/** Agregados pestaña Dashboard Monitoreo PJUD. */
export interface PjudChartBucket {
  key: string;
  label?: string;
  count: number;
}

export interface PjudCharts {
  customerName?: string | null;
  universe?: string;
  inactiveBasis?: string;
  filters?: {
    competency?: string | null;
    causeStatus?: string | null;
    proceduralStage?: string | null;
    admissionFrom?: string | null;
    admissionTo?: string | null;
  };
  totals?: { causes: number };
  competencies?: Array<{ id: number; name: string; count: number }>;
  /** Facets para selects (universo sin filtros activos). */
  causeStatuses?: PjudChartBucket[];
  proceduralStages?: PjudChartBucket[];
  byCauseStatus?: PjudChartBucket[];
  byProceduralStage?: PjudChartBucket[];
  byBusinessStage?: PjudChartBucket[];
  topTribunals?: PjudChartBucket[];
  inactiveByPeriod?: {
    basis?: string;
    buckets?: Array<{ key: string; days: number; count: number }>;
  };
}

export interface PjudConnectedList {
  total: number;
  page: number;
  pageSize: number;
  items: PjudConnectedItem[];
}

export interface PjudNotConnectedList {
  total: number;
  page: number;
  pageSize: number;
  items: PjudNotConnectedItem[];
}

/** Semáforo por registro (mismas claves que statusBreakdown + discovered). */
export type PjudSemaphoreStatus =
  | 'connectedUpToDate'
  | 'connectedOutdated'
  | 'connectedNoMovements'
  | 'connectedPendingReview'
  | 'connectedClosed'
  | 'pending'
  | 'notFound'
  | 'reserved'
  | 'configCredentialError'
  | 'otherErrors'
  | 'discovered';

export interface PjudConnectedItem {
  /** El requerimiento vinculado ya no existe en Flows (se eliminó y el robot siguió con la causa). */
  requirementMissing?: boolean;
  /** ID de la causa en scraping_pjud.causes */
  id: number;
  /** ID del requerimiento Flows (causesCustomers.portalUrl). */
  requirementId?: number | null;
  portalUrl?: string | null;
  rit?: string;
  tribunal?: string;
  cover?: string;
  lastSuccessfulSync?: string;
  scrapingSuccess?: boolean;
  /** causes.scrapingdate: fecha del último INTENTO de revisión del robot. */
  lastScrapeAttempt?: string;
  /** Estado de la causa en PJUD (Tramitación, Suspendido, etc.). */
  causeStatus?: string;
  /** Próxima revisión estimada (scrapingdate + cadencia del estado). */
  nextReview?: string | null;
  competency?: string;
  lastMovementDescription?: string;
  lastMovementDate?: string;
  /** Etapa procesal del último movimiento (causesMovements.stage). */
  lastMovementStage?: string | null;
  syncStatus?: 'upToDate' | 'outdated' | 'pending';
  semaphoreStatus?: PjudSemaphoreStatus;
  daysSinceSync?: number | null;
  /**
   * Vínculo con la causa de alzada: presente cuando ESTA fila es una causa de apelación/suprema.
   * Apunta a la causa de primera instancia que la originó (RIT) y a su requerimiento si el mismo
   * cliente la sigue.
   */
  appealOf?: PjudAppealLink | null;
  /**
   * Causas de alzada (Corte de Apelaciones / Suprema) que referencian a esta causa de primera
   * instancia. Vacío si la causa no tiene apelación asociada seguida por el cliente.
   */
  appeals?: PjudAppealLink[];
}

/** Vínculo a una causa relacionada (origen o apelación) en el monitor PJUD. */
export interface PjudAppealLink {
  rit: string;
  requirementId?: number | null;
  portalUrl?: string | null;
}

export interface PjudNotConnectedItem {
  /** El requerimiento vinculado ya no existe en Flows (se eliminó y el robot siguió con la causa). */
  requirementMissing?: boolean;
  id: number;
  requirementId?: number | null;
  portalUrl?: string | null;
  rit?: string;
  tribunal?: string;
  court?: string | null;
  cover?: string;
  competency?: string;
  errorType?: string | null;
  scrapingDescription?: string | null;
  lastScrapeAttempt?: string;
  semaphoreStatus?: PjudSemaphoreStatus;
  daysPending?: number | null;
}

export interface PjudDiscoveredItem {
  id: number;
  rit?: string;
  tribunal?: string;
  cover?: string;
  createdAt?: string;
  admissionDate?: string | null;
  rut?: string;
  companyName?: string;
  competency?: string;
  daysPending?: number | null;
  semaphoreStatus?: PjudSemaphoreStatus;
}

export type PjudCreateBlockReason =
  | 'quota_exceeded'
  | 'no_matching_types'
  | 'tribunal_unresolved'
  | 'missing_competency'
  | 'missing_tribunal';

export interface PjudCreateTypeOption {
  id: number;
  name: string;
  courtAndTribunal?: {
    court: { id: number | string; name: string };
    tribunal: { id: number | string; name: string };
  };
  type14Prefill?: any;
  /** Nombre del customfield tipo 14 resuelto (Corte/Tribunal), fallback de prefill. */
  courtFieldName?: string | null;
  pjudConfig?: Record<string, any>;
}

export interface PjudCreateTypesResponse {
  allowed: boolean;
  blockReason?: PjudCreateBlockReason | null;
  message?: string | null;
  quota?: { connected: number; planLimit: number; exceeded: boolean };
  types: PjudCreateTypeOption[];
}
